import { DEFAULT_STORE_OBJECT } from '../../contants/common';
import DashboardTypes from './DashboardTypes';

const initialState = {
  openBids: { ...DEFAULT_STORE_OBJECT },
  awardedBids: { ...DEFAULT_STORE_OBJECT },
  openAging: { ...DEFAULT_STORE_OBJECT },
  overallTimeline: { ...DEFAULT_STORE_OBJECT },
  lastSevenDaysData: { ...DEFAULT_STORE_OBJECT },
};

// biome-ignore lint/style/useDefaultParameterLast: <explanation>
const DashboardReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case DashboardTypes.GET_OPEN_BIDS_PROGRESS: {
      return {
        ...state,
        openBids: {
          progressing: true,
          data: payload?.data,
        },
      };
    }

    case DashboardTypes.GET_OPEN_BIDS_SUCCESS: {
      return {
        ...state,
        openBids: {
          success: true,
          data: payload?.data,
        },
      };
    }

    case DashboardTypes.GET_OPEN_BIDS_ERROR: {
      return {
        ...state,
        openBids: {
          error: true,
          ...payload,
        },
      };
    }

    case DashboardTypes.GET_LAST_SEVEN_DAYS_DATA_PROGRESS: {
      return {
        ...state,
        lastSevenDaysData: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
        },
      };
    }

    case DashboardTypes.GET_LAST_SEVEN_DAYS_DATA_SUCCESS: {
      return {
        ...state,
        lastSevenDaysData: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          data: payload?.data,
        },
      };
    }

    case DashboardTypes.GET_LAST_SEVEN_DAYS_DATA_ERROR: {
      return {
        ...state,
        lastSevenDaysData: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
        },
      };
    }
    case DashboardTypes.GET_AWARDED_BIDS_PROGRESS: {
      return {
        ...state,
        awardedBids: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
          data: payload?.data,
        },
      };
    }

    case DashboardTypes.GET_AWARDED_BIDS_SUCCESS: {
      return {
        ...state,
        awardedBids: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          data: payload?.data,
        },
      };
    }

    case DashboardTypes.GET_AWARDED_BIDS_ERROR: {
      return {
        ...state,
        awardedBids: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
        },
      };
    }

    case DashboardTypes.GET_OPEN_AGING_PROGRESS: {
      return {
        ...state,
        openAging: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
          data: payload?.data,
        },
      };
    }

    case DashboardTypes.GET_OPEN_AGING_SUCCESS: {
      return {
        ...state,
        openAging: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          data: payload?.data,
        },
      };
    }

    case DashboardTypes.GET_OPEN_AGING_ERROR: {
      return {
        ...state,
        openAging: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
        },
      };
    }

    case DashboardTypes.GET_OVERALL_TIMELINE_PROGRESS: {
      return {
        ...state,
        overallTimeline: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
          data: payload?.data,
        },
      };
    }

    case DashboardTypes.GET_OVERALL_TIMELINE_SUCCESS: {
      return {
        ...state,
        overallTimeline: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          data: payload?.data,
        },
      };
    }

    case DashboardTypes.GET_OVERALL_TIMELINE_ERROR: {
      return {
        ...state,
        overallTimeline: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
        },
      };
    }
    default:
      return state;
  }
};

export default DashboardReducer;
